import { AppTheme } from '../../../../../main-service/infrastructure/types/features/themes/theme-types';
import { colorsPalette } from '../../colors-palette';

const colors = {
  primaryColor: colorsPalette.beelineYellow500 as Color,
  primaryHoverBtnColor: colorsPalette.beelineYellow400 as Color,
  primaryTextColor: colorsPalette.beelineBlack500 as Color,
  primaryDisabledBgContainer: colorsPalette.beelineYellowOpacity as Color,
  colorTextDisabled: colorsPalette.beelineBlack500Opacity as Color,

  defaultHoverColor: colorsPalette.beelineGray500 as Color,
  defaultHoverBorderColor: colorsPalette.beelineDarkGray400 as Color,
  defaultHoverBg: colorsPalette.beelineGray300 as Color,
  defaultColorText: colorsPalette.beelineBlack400 as Color,

  defaultActiveColor: colorsPalette.beelineGray500 as Color,
  defaultActiveBorderColor: colorsPalette.beelineDarkGray400 as Color,
};

const beelineTheme: AppTheme = {
  id: 'beeline',
  colors: colors,
  font: 'BeelineSansRegular' as Font,
  components: {
    button: {
      primary: {
        brandColor: colorsPalette.beelineYellow500 as Color,
        border: colorsPalette.beelineYellow500 as Color,
        hover: colorsPalette.beelineYellow400 as Color,
        textColor: colorsPalette.beelineBlack500 as Color,
        active: colorsPalette.beelineYellow500 as Color,
      },
      default: {
        hover: colorsPalette.beelineGray500 as Color,
        hoverBorder: colorsPalette.beelineDarkGray400 as Color,
        hoverBackground: colorsPalette.beelineGray300 as Color,
        active: colorsPalette.beelineGray500 as Color,
        activeBorder: colorsPalette.beelineDarkGray400 as Color,
        backgroundDisabled: colorsPalette.beelineYellowOpacity as Color,
        textDisabled: colorsPalette.beelineBlack500Opacity as Color,
      },
    },
    steps: {
      primary: {
        brandColor: colorsPalette.beelineYellow500 as Color,
      },
    },
    notification: {
      info: {
        brandColor: colorsPalette.yellow650 as Color,
      },
      primary: {
        brandColor: colorsPalette.yellow650 as Color,
      },
    },
    progress: {
      default: {
        color: colorsPalette.yellow650 as Color,
      },
    },
    tabs: {
      primary: {
        brandColor: colorsPalette.beelineYellow500 as Color,
      },
    },
    datePicker: {
      primary: {
        brandColor: colorsPalette.beelineYellow500 as Color,
      },
    },
  },
};

export default beelineTheme;
